export function getKeyFromEnum(keyValueArray: any, selectedValue: string): any {
    for (const [key, value] of keyValueArray) {
        if (value === selectedValue) {
            return key;
        }
    }

    return undefined;
}

export function getValueFromEnum(keyValueArray: any, selectedKey: string): any {
    for (const [key, value] of keyValueArray) {
        if (key === selectedKey) {
            return value;
        }
    }

    return undefined;
}

export function getEnumKeysWithValues(keyValueArray: object): Array<{ key: string; value: string }> {
    const enumKeys = Object.keys(keyValueArray);
    const enumKeysLength = enumKeys.length;
    const toRet: Array<{ key: string; value: string }> = [];
    for (let i = 0; i < enumKeysLength / 2; i++) {
        toRet.push({
            key: i.toString(),
            value: enumKeys[enumKeysLength / 2 + i].toString(),
        });
    }
    return toRet;
}

export function getEnumKey(enumValue: object, enumKey: number): string {
    const enumKeys = Object.keys(enumValue);
    const enumKeysLength = enumKeys.length;
    return enumKeys[enumKeysLength / 2 + enumKey].toString();
}

export function getTachoEnumValue(enumKeyValue: object, enumKey: number): string {
    const value: string | undefined = getEnumKeysWithValues(enumKeyValue).find(elem => elem.key === enumKey.toString())?.value;
    if (value) {
        return value;
    }
    return '';
}
